export default {
    init() {
        $(document).on('click', '.matches__filter ul a', function () {
            $('.sl-leagues select').prop('selectedIndex', 0);
            localStorage.removeItem('filter_league_id');
            $('.matches__filter ul a').removeClass('active');
            $(this).addClass('active');
            var filter = $(this).data('filter');
            var data = {
                'action': 'filter_match',
                'filter': filter,
                'league': localStorage.hasOwnProperty('filter_league_id') ? localStorage.getItem('filter_league_id') : '',
            };
    
            jQuery.get(window.ajax_object.ajaxurl, data, function (res) {
                if (res.success) {
                    jQuery('#matches .grid-matches').html(res.data.html);
                    jQuery('a.btn-loadmore').remove();
                    window.dispatchEvent(new CustomEvent('update-match'));
                }
            });
    
            return false;
        });
        jQuery('.sl-leagues select').on('change', function () {
            $('.list-filter a').removeClass('active');
            localStorage.setItem('filter_league_id', $(this).val());
            var data = {
                'action': 'filter_match',
                'filter': 'league',
                'league': $(this).val(),
            };
            jQuery.get(window.ajax_object.ajaxurl, data, function (res) {
                if (res.success) {
                    $('.btn-loadmore').hide();
                    jQuery('#matches .grid-matches').html(res.data.html);
                    window.document.dispatchEvent(new Event('DOMContentLoaded', {
                        bubbles: true,
                        cancelable: true,
                    }));
                }
            });
        });

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js